import { render } from "./ClipboardTap.vue?vue&type=template&id=b76872ec"
import script from "./ClipboardTap.vue?vue&type=script&lang=js"
export * from "./ClipboardTap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__